var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonsGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24331",
    "data-name": "Group 24331",
    transform: "translate(-1290 -1025)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12917",
    "data-name": "Rectangle 12917",
    width: 12,
    height: 12,
    transform: "translate(1290 1025)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_24321",
    "data-name": "Group 24321",
    transform: "translate(412 771)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_003-teamwork",
    "data-name": "003-teamwork",
    transform: "translate(879 255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3923",
    "data-name": "Path 3923",
    d: "M42.154,1.12a1.12,1.12,0,1,0-1.12,1.12A1.121,1.121,0,0,0,42.154,1.12Z",
    transform: "translate(-39.118 0)",
    fill: "#00101a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3924",
    "data-name": "Path 3924",
    d: "M3.833,114.143V113.8A1.917,1.917,0,0,0,0,113.8v.344a.3.3,0,0,0,.3.3h3.23A.3.3,0,0,0,3.833,114.143Z",
    transform: "translate(0 -109.643)",
    fill: "#00101a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3925",
    "data-name": "Path 3925",
    d: "M363.488,1.12a1.12,1.12,0,1,0-1.12,1.12A1.121,1.121,0,0,0,363.488,1.12Z",
    transform: "translate(-353.992 0)",
    fill: "#00101a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3926",
    "data-name": "Path 3926",
    d: "M323.25,111.4a1.919,1.919,0,0,0-1.916,1.916v.344a.3.3,0,0,0,.3.3h3.23a.3.3,0,0,0,.3-.3v-.344A1.919,1.919,0,0,0,323.25,111.4Z",
    transform: "translate(-314.874 -109.161)",
    fill: "#00101a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3927",
    "data-name": "Path 3927",
    d: "M64.877,268.931c0-.022,0-.043,0-.064h-.6a3.85,3.85,0,0,0,1.573,3.172,2.525,2.525,0,0,1,.322-.512A3.246,3.246,0,0,1,64.877,268.931Z",
    transform: "translate(-62.982 -263.462)",
    fill: "#00101a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3928",
    "data-name": "Path 3928",
    d: "M166.047,81.431a3.284,3.284,0,0,1,2.661,0A2.54,2.54,0,0,1,169.2,81a3.892,3.892,0,0,0-3.636,0A2.541,2.541,0,0,1,166.047,81.431Z",
    transform: "translate(-162.232 -78.929)",
    fill: "#00101a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3929",
    "data-name": "Path 3929",
    d: "M354.74,268.867a3.248,3.248,0,0,1-1.291,2.659,2.526,2.526,0,0,1,.322.512,3.85,3.85,0,0,0,1.573-3.172Z",
    transform: "translate(-346.344 -263.462)",
    fill: "#00101a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3930",
    "data-name": "Path 3930",
    d: "M202.821,274.253a1.12,1.12,0,1,0-1.12,1.12A1.121,1.121,0,0,0,202.821,274.253Z",
    transform: "translate(-196.555 -267.642)",
    fill: "#00101a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3931",
    "data-name": "Path 3931",
    d: "M162.583,384.533a1.919,1.919,0,0,0-1.916,1.916v.344a.3.3,0,0,0,.3.3h3.23a.3.3,0,0,0,.3-.3v-.344A1.919,1.919,0,0,0,162.583,384.533Z",
    transform: "translate(-157.437 -376.803)",
    fill: "#00101a"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonsGroup);
export default __webpack_public_path__ + "static/media/persons_group.22a4f8038171aa67e42915fa87083894.svg";
export { ForwardRef as ReactComponent };